import { makeChartComp } from '../../util/makeChartComp';
var FunnelChart = makeChartComp('Funnel');
export default FunnelChart;
